import gql from "graphql-tag";

const ADD_LEAD_TRAFFIC = gql`
  mutation addLeadTraffic($input: LeadTrafficInput!) {
    addLeadTraffic(input: $input) {
      message
      code
    }
  }
`;

export default ADD_LEAD_TRAFFIC;
